  function copy(val) {
      var dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = val;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
      alert('Code Copied!');
    }

    var comSlide = new Swiper('.comment_slide', {
            slidesPerView: 1, 
            spaceBetween: 0,     
            loop:true,  
        autoplay: {
    delay: 2000,
    disableOnInteraction: false, 
  },
            navigation: {
              nextEl: ".com-next",
              prevEl: ".com-prev",
            },
    
      });